import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["theme", "clickable", "href"],
    _excluded2 = ["single", "first"],
    _excluded3 = ["children", "textStyle"];
import React from 'react';
import Text from '../Text';
import RightThinIcon from '../Icons/RightThinIcon';
import LeftThinIcon from '../Icons/LeftThinIcon';
import Box from '../Box';
import Link from '../Link';
import styled, { withTheme } from 'styled-components';
var BreadcrumbDelimeter = withTheme(function (_ref) {
  var theme = _ref.theme,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'left' : _ref$direction;
  var breadcrumbsTheme = theme.breadcrumbs;
  var themeProps = {
    width: breadcrumbsTheme.arrow.width,
    height: breadcrumbsTheme.arrow.height,
    cursor: breadcrumbsTheme.arrow.cursor,
    mr: breadcrumbsTheme.offset
  };
  return direction === 'left' ? /*#__PURE__*/React.createElement(LeftThinIcon, themeProps) : /*#__PURE__*/React.createElement(RightThinIcon, themeProps);
});
var BreadcrumbsWrapper = styled(Box).withConfig({
  displayName: "Breadcrumbs__BreadcrumbsWrapper",
  componentId: "sc-p7owtc-0"
})(["display:flex;align-items:center;"]);

var defaultsBreadcrumb = function defaultsBreadcrumb() {
  return {
    alignItems: 'center',
    display: 'inline-flex'
  };
};

var BreadcrumbLink = withTheme(function (_ref2) {
  var theme = _ref2.theme,
      _ref2$clickable = _ref2.clickable,
      clickable = _ref2$clickable === void 0 ? false : _ref2$clickable,
      href = _ref2.href,
      props = _objectWithoutProperties(_ref2, _excluded);

  var breadcrumbsTheme = theme.breadcrumbs;
  return clickable ? /*#__PURE__*/React.createElement(Link, _extends({}, props, defaultsBreadcrumb(), {
    href: href,
    mr: breadcrumbsTheme.offset
  }), /*#__PURE__*/React.createElement(Text, _extends({
    as: "span",
    color: "ctrl"
  }, defaultsBreadcrumb(), props))) : /*#__PURE__*/React.createElement(Text, _extends({
    as: "span",
    mr: breadcrumbsTheme.offset,
    color: "labelCaption"
  }, defaultsBreadcrumb(), props));
});

var showPrependArrow = function showPrependArrow(single, first) {
  if (single) {
    return true;
  } else {
    return !first;
  }
};

var BreadcrumbInternal = function BreadcrumbInternal(_ref3) {
  var single = _ref3.single,
      first = _ref3.first,
      props = _objectWithoutProperties(_ref3, _excluded2);

  return /*#__PURE__*/React.createElement(BreadcrumbLink, props, showPrependArrow(single, first) && /*#__PURE__*/React.createElement(BreadcrumbDelimeter, {
    direction: single ? 'left' : 'right'
  }), props.children);
};

var Breadcrumb = function Breadcrumb(props) {
  return props.children;
};

Breadcrumb.displayName = 'Breadcrumb';

var Breadcrumbs = function Breadcrumbs(_ref4) {
  var children = _ref4.children,
      _ref4$textStyle = _ref4.textStyle,
      textStyle = _ref4$textStyle === void 0 ? 'bodySmallRegular' : _ref4$textStyle,
      props = _objectWithoutProperties(_ref4, _excluded3);

  var count = React.Children.count(children);
  React.Children.toArray(children).forEach(function (child) {
    var isBreadcrumb = child && child.type && child.type.displayName === 'Breadcrumb';

    if (!isBreadcrumb) {
      throw new Error('Child must be Breadcrumb component');
    }
  });
  return /*#__PURE__*/React.createElement(BreadcrumbsWrapper, _extends({
    textStyle: textStyle
  }, props), React.Children.toArray(children).map(function (child, index) {
    return /*#__PURE__*/React.createElement(BreadcrumbInternal, _extends({
      key: typeof child.key !== 'undefined' ? child.key : index,
      first: index === 0,
      textStyle: textStyle,
      single: count === 1
    }, child.props));
  }));
};

Breadcrumbs.Crumb = Breadcrumb;
export default Breadcrumbs;